import _slicedToArray from "/codebuild/output/src2483311815/src/git-codecommit.eu-west-1.amazonaws.com/v1/repos/sfx_itransfer_agent_portal/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import React__default, { useState } from 'react';
import IconButton from '../../ui/IconButton.js';
import Icon, { IconTypes, IconColors } from '../../ui/Icon.js';
import CreateChannel from '../../CreateChannel.js';
import useSendbirdStateContext from '../../useSendbirdStateContext.js';
import { u as useChannelListContext } from '../../ChannelListProvider-e9a09891.js';
import '../../_rollupPluginBabelHelpers-05128ded.js';
import 'prop-types';
import '../../CreateChannel/components/CreateChannelUI.js';
import '../../CreateChannelProvider-47a1c523.js';
import '../../sendbirdSelectors.js';
import '../../topics-eb548880.js';
import '../../utils-e0c7329c.js';
import '../../CreateChannel/components/InviteUsers.js';
import '../../LocalizationContext-a82461b5.js';
import '../../stringSet-b60e9529.js';
import '../../index-6add7940.js';
import '../../ui/Modal.js';
import 'react-dom';
import '../../index-a9101009.js';
import '../../ui/Button.js';
import '../../index-6420013c.js';
import '../../MediaQueryContext-d6110905.js';
import '../../ui/UserListItem.js';
import '../../UserProfileContext-f3f446d2.js';
import '../../ui/Avatar.js';
import '../../ui/ImageRenderer.js';
import '../../uuid-717930b4.js';
import '../../ui/MutedAvatarOverlay.js';
import '../../ui/Checkbox.js';
import '../../ui/UserProfile.js';
import '../../ui/ContextMenu.js';
import '../../ui/SortByRow.js';
import '../../index-579ca9d7.js';
import '../../utils/message/getOutgoingMessageState.js';
import '../../CreateChannel/components/SelectChannelType.js';
import '../../withSendbird.js';
import '@sendbird/chat/groupChannel';
var AddChannel = function AddChannel() {
  var _state$config;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showModal = _useState2[0],
    setShowModal = _useState2[1];
  var state = useSendbirdStateContext();
  var isOnline = state === null || state === void 0 ? void 0 : (_state$config = state.config) === null || _state$config === void 0 ? void 0 : _state$config.isOnline;
  var disabled = !isOnline;
  var _useChannelListContex = useChannelListContext(),
    overrideInviteUser = _useChannelListContex.overrideInviteUser,
    onBeforeCreateChannel = _useChannelListContex.onBeforeCreateChannel;
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(IconButton, {
    height: "32px",
    width: "32px",
    onClick: function onClick() {
      setShowModal(true);
    },
    disabled: disabled
  }, /*#__PURE__*/React__default.createElement(Icon, {
    type: IconTypes.CREATE,
    fillColor: IconColors.PRIMARY,
    width: "24px",
    height: "24px"
  })), showModal && /*#__PURE__*/React__default.createElement(CreateChannel, {
    onCancel: function onCancel() {
      setShowModal(false);
    },
    overrideInviteUser: overrideInviteUser,
    onCreateChannel: function onCreateChannel() {
      setShowModal(false);
    },
    onBeforeCreateChannel: onBeforeCreateChannel
  }));
};
export { AddChannel, AddChannel as default };